import React from 'react';
import { Tooltip } from '@chakra-ui/react';
var CoreTooltip = function CoreTooltip(_ref) {
  var label = _ref.label,
    placement = _ref.placement,
    hasArrow = _ref.hasArrow,
    isOpen = _ref.isOpen,
    children = _ref.children;
  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Tooltip, {
    isOpen: isOpen,
    hasArrow: hasArrow,
    label: label,
    placement: placement,
    arrowPadding: 4,
    arrowSize: 8
  }, children);
};
CoreTooltip.displayName = "CoreTooltip";
export { CoreTooltip };